import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  status: 'NEW' | 'USED';
  size?: ChipProps['size'];
}

export function StatusBadge({ status, size = 'medium' }: Readonly<StatusBadgeProps>) {
  const { t } = useTranslation();

  return (
    <Chip
      label={status === 'NEW' ? t('search.condition.new') : t('search.condition.used')}
      size={size}
      sx={{
        bgcolor: status === 'NEW' ? 'secondary.main' : 'badge.used',
        color: status === 'NEW' ? 'text.primary' : 'primary.main',
        fontWeight: 600,
        borderRadius: '8px',
        px: 1,
      }}
    />
  );
}
